import { Component, output, OutputEmitterRef } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

// AI entry point shown where an AI agent is available; the icon's twinkle stops on reduced motion.
@Component({
  imports: [MatTooltip, TranslateModule],
  selector: 'app-ai-assist-button',
  standalone: true,
  styleUrl: './ai-assist-button.component.scss',
  templateUrl: './ai-assist-button.component.html',
})
export class AiAssistButtonComponent {
  public readonly assistClick: OutputEmitterRef<void> = output<void>();
}
